export default __webpack_public_path__ + "static/media/person.eb1d2299.svg";